import { Injectable, EventEmitter, inject } from '@angular/core';
import { ControllerStatusService } from './controller-status.service';
@Injectable({
	providedIn: 'root'
})
export class ToolBarActionsService {
	setaTituloEmitter = new EventEmitter<string>();
	controllerStatus = inject(ControllerStatusService);
	constructor() {}

	async getToolBarActionsConfigs() {
		return {
			"/busca": {
				"busca": true,
				"placeholder": placeholder.completo,
				"titulo": "Busca"
			},
			"/clientes": {
				"placeholder": placeholder.semPlaca,
				"showIfAuthorizedName":true,
				"titulo": "Clientes"
			},
			"/cotacao/auto/formulario": {
				"titulo": "Formulário Auto",
			},
			"/cotacao/caminhao/formulario": {
				"titulo": "Formulário Caminhão"
			},
			"/cotacao/motocicleta/formulario": {
				"titulo": "Formulário Motocicleta"
			},
			"/cotacao/residencial/formulario": {
				"titulo": "Formulário Residencial"
			},
			"/cotacao/empresarial/formulario": {
				"titulo": "Formulário Empresarial"
			},
			"/cotacao/condominio/formulario": {
				"titulo": "Formulário Condomínio"
			},
			"/cotacao/auto/formulario/:idIntegracao": {
				"titulo": "Formulário Auto"
			},
			"/cotacao/caminhao/formulario/:idIntegracao": {
				"titulo": "Formulário Caminhão"
			},
			"/cotacao/motocicleta/formulario/:idIntegracao": {
				"titulo": "Formulário Motocicleta"
			},
			"/cotacao/residencial/formulario/:idIntegracao": {
				"titulo": "Formulário Residencial"
			},
			"/cotacao/empresarial/formulario/:idIntegracao": {
				"titulo": "Formulário Empresarial"
			},
			"/cotacao/condominio/formulario/:idIntegracao": {
				"titulo": "Formulário Condomínio"
			},
			"/cotacao/vida/formulario/:idIntegracao": {
				"titulo": "Formulário Vida"
			},
			"/cotacao/:ramo/coberturas/:idIntegracao": {
				"titulo": "Coberturas"
			},
			"/cotacao/:ramo/enviarCalculo/:idIntegracao": {
				"titulo": "Enviar Para Cálculo"
			},
			"/cotacao/:ramo/resultados/:idIntegracao": {
				"titulo": "Resultados"
			},
			"/cotacao/:ramo/simuladorComissoes/:idIntegracao": {
				"titulo": "Simulador De Comissões"
			},
			"/cotacoes": {
				"placeholder": placeholder.semFoneEmail,
				"showIfAuthorizedName":true,
				"titulo": "Cotações",
			},
			"/configuracoes": {
				"titulo": "Configurações"
			},
			"/config-coberturas": {
				"titulo": "Coberturas"
			},
			"/config-corretora": {
				"titulo": "Corretora"
			},
			"/config-ramos": {
				"placeholder": placeholder.ramo,
				"showIfAuthorizedName":true,
				"titulo": "Ramos"
			},
			"/config-seguradoras": {
				"titulo": "Seguradoras"
			},
			"/config-usuarios": {
				"titulo": "Usuários"
			},
			"/meu-plano": {
				"titulo": "Contratação"
			},
			"/online": {
				"placeholder": placeholder.completo,
				"titulo": "Online"
			},
			"/corretoras": {
				"busca": false,
				"filtro": false,
				"placeholder": placeholder.corretora,
				"showIfAuthorizedName":true,
				"titulo": "Corretoras"
			},
			"/dashboard": {
				"placeholder": placeholder.completo,
				"busca": false,
				"filtro": true,
				"showIfAuthorizedName":"TODAS_COTACOES",
				"titulo": "Dashboard"
			},
			"/faturas-nfe": {
				"titulo": "Faturas e NF-e"
			},
			"/orcamento?id=:id&ramo=:ramo": {
				"titulo": "Orçamento"
			},
			"/parcelas": {
				"placeholder": placeholder.completo,
				"titulo": "Parcelas"
			},
			"/perfil-usuario": {
				"titulo": "Perfil Usuário"
			},
			"/preview-orcamento?id=:id": {
				"titulo": "Preview Orçamento"
			},
			"/suporte": {
				"titulo": "Suporte"
			}
		}
	}

	setaTituloPaginaAtual(novoTitulo) {
		this.setaTituloEmitter.emit(novoTitulo);
	}
}

const placeholder = {
	apolice: "Nome / CPF / CNPJ / Placa / Apolice",
	completo: "Nome / CPF / CNPJ / Fone / Email / Placa",
	corretora: "Buscar corretora",
	semFoneEmail: "Nome / CPF / CNPJ / Placa",
	semPlaca: "Nome / CPF / CNPJ / Fone / Email",
	ramo: "Buscar Ramo"
};
